import React from 'react';
import PropTypes from 'prop-types';

import t from '../../lib/I18n';

class Accordion extends React.PureComponent {
    state = {
        isHidden: this.props.isHidden,
        hasBeenUsed: false
    }

    _toggleHidden = () => {
        this.setState(state => ({
            hasBeenUsed: true,
            isHidden: !state.isHidden
        }));
    }

    render() {
        const { children, singleUse } = this.props;
        const { hasBeenUsed, isHidden } = this.state;
        const canShowToggle = !singleUse || !hasBeenUsed;

        return (
            <div className="otrl-accordion">
                { canShowToggle && <span onClick={ this._toggleHidden } className="otrl-accordion__toggle">
                        { t(isHidden ? 'global.showMore' : 'global.showLess') }
                    </span> }
                { !isHidden && children }
            </div>
        );
    }
}

Accordion.propTypes = {
    children: PropTypes.array,
    isHidden: PropTypes.bool,
    singleUse: PropTypes.bool
};

Accordion.defaultProps = {
    isHidden: true,
    singleUse: false
};

export default Accordion;



// WEBPACK FOOTER //
// ./src/components/general/Accordion.js